import {
  SEARCH_INPUT_SOURCING_FILTER1_BUYER,
  SEARCH_OPTION_SOURCING_FILTER2_BUYER,
  SEARCH_OPTION_SOURCING_FILTER3_BUYER,
  SEARCH_OPTION_SOURCING_FILTER4_BUYER,
  SEARCH_OPTION_SOURCING_FILTER5_BUYER,
} from './constants'

const initialStateSearchInput = {
  searchSourcingInput: '',
  enterSearchSourcingFilter: null,
}

const initialStateSearchOption2 = {
  searchOptionSourcingFilter2: '0',
  selectedSourcingOptions2: null,
}

const initialStateSearchOption3 = {
  searchOptionSourcingFilter3: 0,
  selectedSourcingOptions3: null,
}

const initialStateSearchOption4 = {
  searchOptionSourcingFilter4: 0,
  selectedOptionsSourcing4: null,
}
/* seal status */
const initialStateSearchOption5 = {
  searchOptionSourcingFilter5: 0,
  selectedOptionsSourcing5: null,
}

export const searchInputFilterSourcing = (
  state = initialStateSearchInput,
  action
) => {
  switch (action.type) {
    case SEARCH_INPUT_SOURCING_FILTER1_BUYER:
      return {
        ...state,
        searchSourcingInput: action.searchValue,
        enterSearchSourcingFilter: action.enterSearchInputFilter,
      }
    default:
      return state
  }
}
export const searchSelectOptionSourcing2 = (
  state = initialStateSearchOption2,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_FILTER2_BUYER:
      return {
        ...state,
        searchOptionSourcingFilter2: action.searchOption2,
        selectedSourcingOptions2: action.selectedOptions2,
      }
    default:
      return state
  }
}

export const searchSelectOptionSourcing3 = (
  state = initialStateSearchOption3,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_FILTER3_BUYER:
      return {
        ...state,
        searchOptionSourcingFilter3: action.searchOption3,
        selectedSourcingOptions3: action.selectedOptions3,
      }
    default:
      return state
  }
}

export const searchSelectOptionSourcing4 = (
  state = initialStateSearchOption4,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_FILTER4_BUYER:
      return {
        ...state,
        searchOptionSourcingFilter4: action.searchOption4,
        selectedOptionsSourcing4: action.selectedOptions4,
      }
    default:
      return state
  }
}
export const searchSelectOptionSourcing5 = (
  state = initialStateSearchOption5,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_FILTER5_BUYER:
      return {
        ...state,
        searchOptionSourcingFilter5: action.searchOption5,
        selectedOptionsSourcing5: action.selectedOptions5,
      }
    default:
      return state
  }
}
